import { useAdsTotalCountQuery } from 'src/hooks/__generated__/queries';
import type { ExtendedAdsQueryVariables } from '../types/extendedAdsQueryVariables';
import { AdStatuses, type GeometryWithSource } from 'src/types/__generated__/graphql';

type Params = {
    placeGeometry?: GeometryWithSource;
    parameters: ExtendedAdsQueryVariables;
};

export const useAdsTotalCount = ({ placeGeometry, parameters }: Params) => {
    const { data, loading } = useAdsTotalCountQuery({
        variables: {
            ...parameters,
            places: placeGeometry
                ? [
                      {
                          type: placeGeometry.type,
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                          coordinates: placeGeometry.coordinates,
                      },
                  ]
                : undefined,
            statuses: [AdStatuses.Available],
            limit: 1, // we only need the count so we limit to 1
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        adsTotalCount: data?.ads?.totalCount,
        loading,
    };
};
